import clsx from "clsx";

interface Props {
  onClose(): void;
}

export const AboutPanelBenchmarks = ({ onClose }: Props) => (
  <div className="text-xs font-normal py-3 px-4">
    <button
      className="text-primary font-semibold mb-3 hover:bg-cosmic-5 pl-1.5 pr-2 py-2 rounded-2xl"
      onClick={onClose}
    >
      <i
        className={clsx(
          "fa-regular fa-sharp fa-arrow-left text-[0.8rem]",
          "text-primary mt-0.5 mr-1 w-4",
        )}
      />
      BACK
    </button>
    <div className="text-gray+1 font-light mb-1">Metric Category</div>
    <p className="mb-5">Platform benchmark</p>
    <div className="text-gray+1 font-light mb-1">How it&apos;s calculated</div>
    <p className="mb-5">
      This is a customer configured value. See{" "}
      <button className="text-primary underline">platform benchmarks</button>
    </p>
    <div className="text-gray+1 font-light mb-1">More</div>
    <p className="mb-0">
      The % change shows the difference between your benchmark and Northbeam’s
      reported value for the metric
    </p>
  </div>
);
